module.exports = __webpack_public_path__ + "static/media/HomeRoll_Walls_FibCFibWall.a7047e23.jpg";